// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import CallList from "./call-list.js"
import Contact from "./contact.js"
import PhoneNumber from "./phone-number.js"
import User from "./user.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "call_list_id": {
      "column": {
        "default": null,
        "name": "call_list_id",
        "null": false,
        "type": "uuid"
      },
      "name": "call_list_id",
      "selected_by_default": null,
      "translated": null
    },
    "contact_id": {
      "column": {
        "default": null,
        "name": "contact_id",
        "null": false,
        "type": "uuid"
      },
      "name": "contact_id",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "current_caller_id": {
      "column": {
        "default": null,
        "name": "current_caller_id",
        "null": true,
        "type": "uuid"
      },
      "name": "current_caller_id",
      "selected_by_default": null,
      "translated": null
    },
    "deleted_at": {
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      },
      "name": "deleted_at",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": null,
        "name": "state",
        "null": false,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    },
    "phone_number_id": {
      "column": {
        "default": null,
        "name": "phone_number_id",
        "null": true,
        "type": "uuid"
      },
      "name": "phone_number_id",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "comment": {
      "column": {
        "default": "",
        "name": "comment",
        "null": false,
        "type": "string"
      },
      "name": "comment",
      "selected_by_default": null,
      "translated": null
    },
    "translated_state": {
      "column": null,
      "name": "translated_state",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "CallListEntity",
  "collectionKey": "call_list_entities",
  "collectionName": "call_list_entities",
  "i18nKey": "call_list_entity",
  "camelizedLower": "callListEntity",
  "name": "CallListEntity",
  "nameDasherized": "call-list-entity",
  "pluralName": "call_list_entities",
  "ransackable_associations": [
    {
      "className": "CallList",
      "collectionName": "call_lists",
      "foreignKey": "call_list_id",
      "name": "call_list",
      "macro": "belongs_to",
      "resource_name": "CallList",
      "through": null
    },
    {
      "className": "Comment",
      "collectionName": "comments",
      "foreignKey": "commentable_id",
      "name": "comments",
      "macro": "has_many",
      "resource_name": "Comment",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "current_caller_id",
      "name": "current_caller",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "organization_id",
      "name": "organization",
      "macro": "has_one",
      "resource_name": "Organization",
      "through": "contact"
    },
    {
      "className": "Person",
      "collectionName": "people",
      "foreignKey": "person_id",
      "name": "person",
      "macro": "has_one",
      "resource_name": "Person",
      "through": "contact"
    },
    {
      "className": "PhoneNumber",
      "collectionName": "phone_numbers",
      "foreignKey": "phone_number_id",
      "name": "phone_number",
      "macro": "belongs_to",
      "resource_name": "PhoneNumber",
      "through": null
    },
    {
      "className": "PhoneNumber",
      "collectionName": "phone_numbers",
      "foreignKey": "contact_id",
      "name": "phone_numbers",
      "macro": "has_many",
      "resource_name": "PhoneNumber",
      "through": "contact"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "user",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "call_list_id",
      "column": {
        "default": null,
        "name": "call_list_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "comment",
      "column": {
        "default": "",
        "name": "comment",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "contact_id",
      "column": {
        "default": null,
        "name": "contact_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "current_caller_id",
      "column": {
        "default": null,
        "name": "current_caller_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "deleted_at",
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_call_list_id",
      "column": {
        "default": null,
        "name": "old_call_list_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_contact_id",
      "column": {
        "default": null,
        "name": "old_contact_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_current_caller_id",
      "column": {
        "default": null,
        "name": "old_current_caller_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_phone_number_id",
      "column": {
        "default": null,
        "name": "old_phone_number_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_user_id",
      "column": {
        "default": null,
        "name": "old_user_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "phone_number_id",
      "column": {
        "default": null,
        "name": "phone_number_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "state",
      "column": {
        "default": null,
        "name": "state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "user_id",
      "column": {
        "default": null,
        "name": "user_id",
        "null": true,
        "type": "uuid"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "CallList",
      "collectionName": "call_lists",
      "foreignKey": "call_list_id",
      "name": "call_list",
      "macro": "belongs_to",
      "resource_name": "CallList",
      "through": null
    },
    {
      "className": "PhoneNumber",
      "collectionName": "phone_numbers",
      "foreignKey": "phone_number_id",
      "name": "phone_number",
      "macro": "belongs_to",
      "resource_name": "PhoneNumber",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "user",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    }
  ],
  "paramKey": "call_list_entity",
  "primaryKey": "id"
}

/** Frontend model for CallListEntity. */
export default class CallListEntity extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  callListId() {
    return this.readAttributeUnderscore("call_list_id")
  }

  /** @returns {boolean} */
  hasCallListId() {
    const value = this.callListId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  contactId() {
    return this.readAttributeUnderscore("contact_id")
  }

  /** @returns {boolean} */
  hasContactId() {
    const value = this.contactId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  currentCallerId() {
    return this.readAttributeUnderscore("current_caller_id")
  }

  /** @returns {boolean} */
  hasCurrentCallerId() {
    const value = this.currentCallerId()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  deletedAt() {
    return this.readAttributeUnderscore("deleted_at")
  }

  /** @returns {boolean} */
  hasDeletedAt() {
    const value = this.deletedAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  phoneNumberId() {
    return this.readAttributeUnderscore("phone_number_id")
  }

  /** @returns {boolean} */
  hasPhoneNumberId() {
    const value = this.phoneNumberId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  comment() {
    return this.readAttributeUnderscore("comment")
  }

  /** @returns {boolean} */
  hasComment() {
    const value = this.comment()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedState() {
    return this.readAttributeUnderscore("translated_state")
  }

  /** @returns {boolean} */
  hasTranslatedState() {
    const value = this.translatedState()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static currentCall(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "current_call",
        collectionName: "call_list_entities",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  setCurrentCaller(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "set_current_caller",
        primaryKey: this.primaryKey(),
        collectionName: "call_list_entities",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  unsetCurrentCaller(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "unset_current_caller",
        primaryKey: this.primaryKey(),
        collectionName: "call_list_entities",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./contact.js").default | null} */
  contact() {
    return this._readBelongsToReflection({modelClass: Contact, reflectionName: "contact"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadContact() {
    if (!("contactId" in this)) throw new Error("Foreign key method wasn't defined: contactId")

    const id = this.contactId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "contact",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureContactLoaded() {
    return this.ensureAssociationLoaded("contact")
  }

  /** @returns {import("./call-list.js").default | null} */
  callList() {
    return this._readBelongsToReflection({modelClass: CallList, reflectionName: "call_list"})
  }

  /** @returns {Promise<import("./call-list.js").default | null>} */
  loadCallList() {
    if (!("callListId" in this)) throw new Error("Foreign key method wasn't defined: callListId")

    const id = this.callListId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "call_list",
        model: this,
        modelClass: CallList
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./call-list.js").default | null>} */
  ensureCallListLoaded() {
    return this.ensureAssociationLoaded("call_list")
  }

  /** @returns {import("./phone-number.js").default | null} */
  phoneNumber() {
    return this._readBelongsToReflection({modelClass: PhoneNumber, reflectionName: "phone_number"})
  }

  /** @returns {Promise<import("./phone-number.js").default | null>} */
  loadPhoneNumber() {
    if (!("phoneNumberId" in this)) throw new Error("Foreign key method wasn't defined: phoneNumberId")

    const id = this.phoneNumberId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "phone_number",
        model: this,
        modelClass: PhoneNumber
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./phone-number.js").default | null>} */
  ensurePhoneNumberLoaded() {
    return this.ensureAssociationLoaded("phone_number")
  }

  /** @returns {import("./user.js").default | null} */
  user() {
    return this._readBelongsToReflection({modelClass: User, reflectionName: "user"})
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  loadUser() {
    if (!("userId" in this)) throw new Error("Foreign key method wasn't defined: userId")

    const id = this.userId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "user",
        model: this,
        modelClass: User
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  ensureUserLoaded() {
    return this.ensureAssociationLoaded("user")
  }
}
